
const updateTableHeaderPosition = () => {
    jQuery(document).ready(function ($) {
        let bannerHeight = 0;
        const headerHeight = $('header').outerHeight();

        if ($('.banner').length > 0 && !$('.banner').hasClass("banner-hidden")) {
            bannerHeight = $('.banner').outerHeight();
        }

        if ($('.country-banner').length > 0 && !$('.country-banner').hasClass("banner-hidden")) {
            bannerHeight += $('.country-banner').outerHeight();
        }

        if ($('#wpadminbar').length > 0) {
            bannerHeight += $('#wpadminbar').outerHeight();
        }

        if ($('.comparison-table__table table thead tr th').length) {
            $('.comparison-table__table table thead tr th').css('top', bannerHeight + headerHeight + 'px');
        }
    });
};

const ComparisonTable = () => {
    jQuery(document).ready(function ($) {
    $('.comparison-table .custom-select').on('change', function () {
        const $select = $(this);
        const selectedValue = $select.val(); 
        const $table = $('.comparison-table__table table');
        const tbody = $('.comparison-table__table table tbody');
        const dataFields = tbody.data('fields'); 
        const $th = $select.closest('th');
        const columnIndex = $th.index(); 

        const currentTaxonomy = $th.data('taxonomy'); 
        if (!$th.find('.loading-animation').length) {
            $th.append('<div class="loading-animation"></div>');
        }
    
        const $animationContainer = $th.find('.loading-animation');
    
        
        const animationInstance = lottie.loadAnimation({
            container: $animationContainer[0], 
            renderer: 'svg',
            loop: true,
            autoplay: true,
            path: `${window.location.protocol}//${window.location.hostname}/wp-content/themes/xometry/dist/img/loading-spinner.json`
        });
    
      
        $animationContainer.show();
        const data = {
            action: 'update_comparison_table',
            term_id: selectedValue,
            fields: dataFields,
            current_taxonomy: currentTaxonomy
        };
        

        $.ajax({
            url: scripts_data.ajax_url,
            type: 'POST',
            data: data,
            success: function (response) {
                if (response.success) {
                    const newTaxonomy = response.data.new_taxonomy; 
                    const fieldData = response.data.fields; 
                    const shortDescription = response.data.short_description; 
                    const serviceLink = response.data.service_link; 

                    const $shortDescription = $th.find('.short_description');
                    if ($shortDescription.length > 0) {
                        $shortDescription.text(shortDescription); 
                    } else {
                        $th.append(`<div class="text-m short_description">${shortDescription}</div>`);
                    }

                    $th.data('taxonomy', newTaxonomy);
                    $th.attr('data-taxonomy', newTaxonomy);

                    const $rows = $table.find('tbody tr');
                    $rows.each(function (rowIndex, row) {
                        const $cells = $(row).find('td');
                        const $cell = $cells.eq(columnIndex);

                        if (fieldData[rowIndex]) {
                            const { title, value } = fieldData[rowIndex];
                            let cellContent = `<h4 class='text-s'>${title}</h4>`;

                            if (Array.isArray(value)) {
                                cellContent += "<ul>";
                                value.forEach(item => {
                                    cellContent += `<li>${item}</li>`;
                                });
                                cellContent += "</ul>";
                            } else {
                                cellContent += `<p>${value}</p>`;
                            }

                            $cell.html(cellContent);
                            $cell.attr('data-taxonomy', newTaxonomy);
                        }
                    });

                    const $linkRow = $table.find('tr.row-with-link');
                    const $linkCell = $linkRow.find(`td[data-taxonomy="${currentTaxonomy}"]`);
                    if ($linkCell.length > 0) {
                        $linkCell.attr('data-taxonomy', newTaxonomy); 
                        if (serviceLink?.url) {
                            const linkText = scripts_data.exploreText.replace('%s', newTaxonomy);
                            const linkHtml = `
                                <a href="${serviceLink.url}" class="text-btn">
                                    ${linkText}
                                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                        <path d="M1.66794 10.8333L16.3228 10.8333L13.5787 13.5774C13.2533 13.9028 13.2533 14.4305 13.5787 14.7559C13.9041 15.0814 14.4318 15.0814 14.7572 14.7559L18.9239 10.5893C19.2493 10.2639 19.2493 9.7362 18.9239 9.41075L14.7572 5.24409C14.5945 5.08137 14.3812 4.99998 14.1679 4.99998C13.9547 4.99998 13.7414 5.08137 13.5787 5.24409C13.2533 5.56948 13.2533 6.09714 13.5787 6.42259L16.3228 9.16664L1.66794 9.16664C1.20772 9.16664 0.834609 9.53975 0.834609 9.99997C0.834608 10.4602 1.20772 10.8333 1.66794 10.8333Z" fill="#1A5ADE"/>
                                    </svg>
                                </a>`;
                            $linkCell.html(linkHtml); 
                        } else {
                            $linkCell.empty(); 
                        }
                    }
                } else {
                    console.error('Error: ', response.data.message);
                }
            },
            error: function (error) {
                console.error('AJAX Error: ', error);
            },
            complete: function () {
                $animationContainer.hide();
                animationInstance.destroy(); 
            }
        });
    });

    updateTableHeaderPosition();

    $(window).on('resize', updateTableHeaderPosition);
});
};



export default ComparisonTable;